import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import Header from './Header';
import TeamModal from '../../../common/components/Team';
import { getColumns, DEFAULTSORTED, DEFAULTPAGESIZE } from './table.conf.js';
import { updateInPath, nullsToStrings, } from '../../../../common/utils';

class Teams extends Component {
  constructor(props) {
    super();

    this.state = {
      teamModal: {
        opened: false,
        data: []
      }
    };
  }

  handleTeamModalClose = (refreshData) => {
    this.setState(s => updateInPath(s, 'teamModal.opened', false));
    if (refreshData) {
      this.props.refresh();
    }
  }

  handleTeamModalSave = (data) => {
    this.setState(s => updateInPath(s, 'teamModal.opened', false));
    this.props.onTeamSave(data);
  };

  handleTeamModalOpen = ({ teamId, userId }) => {
    this.props.onTeamView(teamId, userId, (team) => {
      this.setState(s => updateInPath(s, 'teamModal.data', nullsToStrings(team)));
      this.setState(s => updateInPath(s, 'teamModal.opened', true));
    });
  }

  handleTeamModalDelete = (teamId, userId) => {
    this.setState(s => updateInPath(s, 'teamModal.opened', false));
    this.props.onTeamDelete(teamId, userId);
  };

  render() {
    const { data, events, refresh, onUpdatePayment, loading, onDownloadTeamsCsv } = this.props;

    const teamModal = this.state.teamModal;
    
    return (
      <div>
        { teamModal.opened && <TeamModal
                                open={teamModal.opened}
                                data={teamModal.data}
                                events={events}
                                onSave={this.handleTeamModalSave}
                                onDelete={this.handleTeamModalDelete}
                                onClose={this.handleTeamModalClose} />}
        <Header
          events={events}
          disabled={loading}
          onSubmit={refresh}
          onDownload={onDownloadTeamsCsv}
        />
        <ReactTable
          ref={ (r) => { this.reactTable = r; } } 
          className='-striped -highlight'
          data={data}
          loading={loading}
          getTrProps={(state, rowInfo, column) => ({
            onClick: e => this.handleTeamModalOpen(rowInfo.original)
          })}
          columns={getColumns(onUpdatePayment, this.reactTable)}
          defaultSorted={DEFAULTSORTED}
          defaultPageSize={DEFAULTPAGESIZE}
        />
      </div>
    );
  };
};

export default Teams;



// WEBPACK FOOTER //
// ./src/private/admin/components/Teams/index.js